import { lazy, Suspense } from "react";

import { DrawerContent, SwipeableDrawer } from "@/components/Drawer";
import { AnimatedLoader } from "@/components/Loaders/AnimatedLoader";
import { PageLoader } from "@/components/Loaders/PageLoader";
import { useLocaleInfo } from "@/hooks/useLocaleInfo";

const ArabicTerms = lazy(() => import("./ArabicTerms"));
const EnglishTerms = lazy(() => import("./EnglishTerms"));

export const MoreDetailsDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { locale } = useLocaleInfo();

  return (
    <SwipeableDrawer
      onClose={onClose}
      open={open}
      hasFullHeight
      heightOffset={100}
    >
      <DrawerContent>
        <div className="prose-sm">
          <Suspense
            fallback={
              <PageLoader>
                <AnimatedLoader icon="users" />
              </PageLoader>
            }
          >
            {locale === "ar" ? <ArabicTerms /> : <EnglishTerms />}
          </Suspense>
        </div>
      </DrawerContent>
    </SwipeableDrawer>
  );
};
